import React, { useEffect, useState } from "react";
import axios from "axios";
import { Upload, Button, Select, Form, Input, Spin, Row, Col } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import "react-chatbot-kit/build/main.css";
import BodhiLogo from "../assets/avatar.png";
import { data } from "react-router-dom";

const dataTypeOptions = [
  { name: "BSA Retail (Raw)", value: "bsa_exist_retail" },
  { name: "BSA Corp (Raw)", value: "bsa_exist_corp" },
  { name: "BSA Retail (Reporting)", value: "bsa_new_retail" },
  { name: "BSA Corp (Reporting)", value: "bsa_new_corp" },
  { name: "ITR 26AS", value: "itr_26as" },
  { name: "ITR", value: "itr_ITR" },
  { name: "Legal Corp 1", value: "legal_corp1" },
  { name: "Legal Corp 2", value: "legal_corp2" },
  { name: "Legal Retail 1", value: "legal_retail1" },
  { name: "Legal Retail 2", value: "legal_retail2" },
  { name: "GST1", value: "gst1" },
  { name: "GST2", value: "gst2" },
  { name: "Generic Excel", value: "excel" },
];

function Home({ onUploadSuccess }) {
  const { Option } = Select;

  const [pretext, setPretext] = useState();

  /* const [showChatbot, setShowChatbot] = useState(false); */
  const [showChatbutton, setShowChatbutton] = useState(true);
  const [uploadStatus, setUploadStatus] = useState({});
  const [fileList, setFileList] = useState([]); // Track file list

  const [isUploadEnabled, setIsUploadEnabled] = useState(false); // New state
  const [form] = Form.useForm();

  const [isFormDisabled, setIsFormDisabled] = useState(false); // New state
  const [userId, setUserId] = useState(""); // New state
  const [companyName, setCompanyName] = useState(""); // New state

  useEffect(() => {
    localStorage.clear(); // Clear all data
  }, []); // Runs only on first render

  useEffect(() => {
    const cheqdJwt = localStorage.getItem("imt__token");

    const pretexts = localStorage.getItem("imt__pretexts");
    const { [cheqdJwt]: _pretext } = JSON.parse(pretexts || "{}");
    setPretext(_pretext);
  }, []);

  /*   const validateInput = (input) => {
    return input.length > 0 && input.trim().length !== 0;
  }; */

  const MAX_FILE_NAME_LENGTH = 20; // Maximum length for the file name

  // Helper function to truncate file names
  const truncateFileName = (name) => {
    if (name.length <= MAX_FILE_NAME_LENGTH) return name;
    const extIndex = name.lastIndexOf(".");
    const extension = extIndex !== -1 ? name.slice(extIndex) : "";
    const truncated = name.slice(
      0,
      MAX_FILE_NAME_LENGTH - extension.length - 3
    );
    return `${truncated}...${extension}`;
  };
  const saveToLocalStorage = () => {
    const { userId, companyName } = form.getFieldsValue(); // Get form values
    if (userId) {
      localStorage.setItem("user_id", userId);
      // localStorage.setItem("company_name", companyName);
    }
  };
  const handleFileChange = ({ file, fileList }) => {
    // Map file list to update truncated names
    const updatedFileList = fileList.map((file) => ({
      ...file,
      truncatedName: truncateFileName(file.name), // Add truncated name
      dataTypeNew: file.dataTypeNew,
    }));

    setFileList(updatedFileList); // Update state with truncated names

    if (file.status === "removed") {
      // Remove status and data type if file is removed
      setUploadStatus((prevStatus) => {
        const { [file.uid]: _, ...rest } = prevStatus;
        return rest;
      });
    }
  };
  const handleUpload = ({ file, onSuccess, onError }) => {
    form
      .validateFields()
      .then((values) => {
        const { userId, companyName, dataType } = values;

        const formData = new FormData();
        formData.append("user_id", userId);
        // formData.append("company_name", companyName);
        formData.append(
          "data_type",
          dataType === "bsa_exist_corp" ? "bsa_exist_retail" : dataType
        );
        formData.append("file", file);

        setUploadStatus((prevStatus) => ({
          ...prevStatus,
          [file.uid]: "Uploading...", // Set initial uploading status
        }));

        axios
          .post(`${process.env.REACT_APP_API_URL}/upload_json`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              setUploadStatus((prevStatus) => ({
                ...prevStatus,
                [file.uid]: `Uploading...`, // Show progress
              }));
            },
          })
          .then(() => {
            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              [file.uid]: "Uploaded", // Success status
            }));
            setShowChatbutton(false);
            setIsFormDisabled(true); // Disable form fields after successful uplo
            file.dataTypeNew = dataType;
            onSuccess("ok");
            saveToLocalStorage();
          })
          .catch((error) => {
            setUploadStatus((prevStatus) => ({
              ...prevStatus,
              [file.uid]: "Error", // Error status
            }));
            file.dataTypeNew = dataType;
            onError(error);
          });
      })
      .catch(() => {
        setUploadStatus((prevStatus) => ({
          ...prevStatus,
          [file.uid]: "Validation Failed", // Error on validation failure
        }));

        onError("Validation Failed");
      });
  };

  const handleFileRemove = (file) => {
    // Remove file from file list
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));

    // Remove file from upload status
    setUploadStatus((prevStatus) => {
      const { [file.uid]: _, ...rest } = prevStatus; // Remove status for this file
      return rest;
    });
  };

  const checkFormFields = (_, allFields) => {
    const { userId, companyName } = form.getFieldsValue(); // Capture values from the form
    setUserId(userId);
    // setCompanyName(companyName);
    setIsUploadEnabled(!!userId ); // Set state based on values
  };

  return (
    <div className="App flex justify-center items-center h-screen">
      <header className="App-header w-[100%]">
        <>
          <label className="block text-[#005e99] text-2xl lg:text-3xl font-bold mb-2 pt-5">
            {process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"}
          </label>
          <img src={BodhiLogo} alt="Bodhi" className="m-3 w-32 pt-2 lg:pt-5" />
          <Form
            form={form}
            className="flex flex-col items-center mt-1 lg:mt-2"
            layout="vertical"
            onFieldsChange={checkFormFields} // Monitor form changes
            initialValues={{ dataType: "bsa_exist_retail" }}
          >
            {/*  */}
            <Form.Item
                  name="userId"
                  label="User ID"
                  rules={[
                    { required: true, message: "Please enter your User ID" },
                  ]}
                >
                  <Input
                    placeholder="Enter your User ID"
                    disabled={isFormDisabled}
                  />
            </Form.Item>
            <hr className="form-divider" />
            <div className="flex">
              <Form.Item
                name="dataType"
                label="Data Type"
                style={{
                  width: "100%",
                  marginRight: "10px",
                }}
              >
                <Select
                  style={{
                    width: "100%",
                  }}
                  dropdownStyle={{ minWidth: "150px" }}
                >
                  {/* <Option value="bsa_exist_retail">BSA Retail (Raw)</Option>
                  <Option value="bsa_exist_corp">BSA Corp (Raw)</Option>
                  <Option value="bsa_new_retail">BSA Retail (Reporting)</Option>
                  <Option value="bsa_new_corp">BSA Corp (Reporting)</Option>
                  <Option value="itr_26as">ITR 26AS</Option>
                  <Option value="itr_ITR">ITR</Option>
                  <Option value="legal_corp1">Legal Corp 1</Option>
                  <Option value="legal_corp2">Legal Corp 2</Option>
                  <Option value="legal_retail1">Legal Retail 1</Option>
                  <Option value="legal_retail2">Legal Retail 2</Option>
                  <Option value="gst1">GST1</Option>
                  <Option value="gst2">GST2</Option> */}
                  {dataTypeOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Upload Files">
                <Upload
                  customRequest={handleUpload}
                  fileList={fileList}
                  disabled={!isUploadEnabled} // Disable if conditions not met
                  onChange={handleFileChange}
                  showUploadList={{
                    showDownloadIcon: false,
                    showRemoveIcon: false,
                  }}
                  style={{
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                  itemRender={(originNode, file) => (
                    <div
                      className={
                        uploadStatus[file.uid] === "Error"
                          ? "upload-status-error"
                          : uploadStatus[file.uid] === "Uploaded"
                          ? "upload-status-success"
                          : "upload-status-progress"
                      }
                    >
                      {uploadStatus[file.uid]?.includes("Uploading") ? (
                        <Spin size="small" style={{ marginRight: "10px" }} /> // Loader for uploading
                      ) : (
                        <></>
                      )}
                      <span>{file.truncatedName || file.name}</span>
                      {file.dataTypeNew && (
                        <span style={{ marginLeft: "10px", background: "#f0f0f0", padding: "2px 5px", borderRadius: "4px" }}>
                          {
                            dataTypeOptions.find(
                              (option) => option.value === file.dataTypeNew
                            )?.name
                          }
                        </span>
                      )}
                      {uploadStatus[file.uid] === "Error" && (
                        <DeleteOutlined
                          style={{
                            color: "red",
                            cursor: "pointer",
                            marginLeft: "10px",
                          }}
                          onClick={() => handleFileRemove(file)}
                        />
                      )}
                    </div>
                  )}
                >
                  <Button icon={<UploadOutlined />} disabled={!isUploadEnabled}>
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </div>
          </Form>
          <button
            onClick={() => {
              onUploadSuccess({ userId, companyName });
            }}
            className="chat-button mb-1 lg:mb-2"
            disabled={showChatbutton}
          >
            {/* Go to Chat */}
            Next
          </button>
        </>
      </header>
    </div>
  );
}

export default Home;
